<template>
  <div>
    <v-card-title class="pt-0 pb-2" :class="$vuetify.theme.dark ? '' : 'primary'">
      <v-tabs v-model="sectionModel" dark height="35"
        :background-color="$vuetify.theme.dark ? '' : 'primary'" slider-color="white">
        <v-tab v-for="(section, i) in availableSections" :key="i" v-show="groupedSections[section]">
          <v-icon small class="me-2" :color="getSectionColor(section)">{{ getSectionIcon(section) }}</v-icon>
          <span class="body-2 monospace-font" :class="$vuetify.theme.dark ? 'primary--text' : 'white--text'">
            {{ getSectionName(section) }}
          </span>
        </v-tab>
      </v-tabs>
    </v-card-title>
    <v-tabs-items v-model="sectionModel" class="px-5 py-2">
      <v-tab-item v-for="(section, i) in availableSections" :key="i" v-show="groupedSections[section]">
        <!--Not showing seasons-->
        <v-btn x-small outlined color="primary" class="ma-1 py-4 px-2" elevation="0"
          :class="{'grey lighten-1': showActiveStyle(league) && !$vuetify.theme.dark, 'lightSecondary': showActiveStyle(league) && $vuetify.theme.dark , 'black lighten-3': $vuetify.theme.dark && !showActiveStyle(league), 'grey lighten-4': !$vuetify.theme.dark && !showActiveStyle(league)}"
          v-if="!showSeasons"
          :value="league.id" :key="league.id" 
          v-for="league in groupedSections[sectionModel]"
          @click="onLeagueClick(league)"
        >
          <img contain class="me-2" height="16"
            :src="'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/' + league.id + '.png'"
            @error="onImageLoadFailure($event)"
          />
          <span v-if="league.label" class="font-weight-bold">{{league.label}}</span>
          <v-badge tile dot color="green" v-if="league.seasonActive" offset-y="-8" offset-x="-0.4"></v-badge>
        </v-btn>
        <!--Show seasons-->
        <v-menu v-if="showSeasons" bottom rounded offset-y v-for="league in groupedSections[sectionModel]" :key="league.id">
          <template v-slot:activator="{ on, attrs }">
            <v-btn x-small outlined color="primary" class="ma-1 py-4 px-2" elevation="0"
              :class="{'grey lighten-1': showActiveStyle(league) && !$vuetify.theme.dark, 'lightSecondary': showActiveStyle(league) && $vuetify.theme.dark , 'black lighten-3': $vuetify.theme.dark && !showActiveStyle(league), 'grey lighten-4': !$vuetify.theme.dark && !showActiveStyle(league)}"
              :value="league.id" :key="league.id" 
              v-bind="attrs" v-on="on"
            >
              <img contain class="me-2" height="16"
                :src="'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/' + league.id + '.png'"
                @error="onImageLoadFailure($event)"
              />
              <span v-if="league.label" class="font-weight-bold">{{league.label}}</span>
              <v-badge tile dot color="green" v-if="league.seasonActive" offset-y="-8" offset-x="-0.4"></v-badge>
            </v-btn>
          </template>
          <v-list rounded dense>
            <v-list-item v-for="(year,index) in league.years" :key="index" @click="onYearClick(year, league)">
              <v-list-item-content>
                <v-list-item-title>{{ year }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
export default {
  name: 'LeagueSectionTabs',
  props: {
    groupedSections: {
      type: Object,
      default: () => {},        
      required: true
    },
    availableSections: {
      type: Array,
      default: () => [],
      required: true,
    },
    selectedLeague: {
      type: Object,
      default: () => {},
      required: false
    },
    searchedLeague: {
      type: Object,
      default: () => {},
      required: false
    },
    showSeasons: {
      type: Boolean,
      default: false
    },
    areaName: {
      type: String,
      default: "",
      required: false
    }
  },
  data() {
    return {
      sectionModel: 1
    }
  },
  mounted() {
    //Go to searched league tab
    if (this.searchedLeague) this.sectionModel = this.searchedLeague.tabSection;
    if (this.selectedLeague) this.sectionModel = this.selectedLeague.tabSection;
    //Go to first available section
    if (!this.sectionModel || !this.groupedSections[this.sectionModel]) {
      this.sectionModel = Number(Object.keys(this.groupedSections)[0]);
    };
  },
  methods: {
    onImageLoadFailure(event) {
      event.target.src = "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png";
    },
    onLeagueClick(league){
      this.$emit('leagueClicked', league);
    },
    onYearClick(year, league){
      this.$emit('yearClicked', { year, league });
    },
    getSectionName(section) {
      switch(section) {
        case 0:
          return this.$t('leagueTypes.continental');
        case 1:
          return this.areaName === "Youth" ? 'U23-U21' : this.$t('playerScout.division1');
        case 2:
          return this.areaName === "Youth" ? 'U20-U19' : this.$t('playerScout.division2');
        case 3:
          return this.areaName === "Youth" ? 'U18-U17' : this.$t('playerScout.division3');
        case 4:
          return this.areaName === "Youth" ? 'U16-U15' : this.$t('playerScout.division4');
        case 5:
          return this.areaName === "Youth" ? 'U14-U12' : this.$t('playerScout.division5');
        case 6:
          return this.$t('leagueTypes.nationalTeam');
        case 7:
          return this.$t('gbe.other');
        default:
          return section;
      };
    },
    getSectionIcon(section) {
      switch(section) {
        case 0:
          return "star";
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          return "emoji_events";
        case 6:
          return "flag";
        default:
          return "";
      };
    },
    getSectionColor(section) {
      if (this.areaName === "Youth") return "grey lighten-3";
      // Regular competitions
      switch(section) {
        case 0:
        case 6:
          return "grey lighten-1";
        case 1:
          return "yellow accent-4";
        case 2:
          return this.$vuetify.theme.dark ? "grey lighten-1" : "blue-grey";
        case 3:
          return "brown";
        default:
          return "grey lighten-3";
      };
    },
    showActiveStyle(league) {
      return (this.searchedLeague && this.searchedLeague.id === league.id) || (this.selectedLeague && this.selectedLeague.id === league.id);
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/league/league-selector/LeagueSectionTabs.vue